import axios from "axios";
import { useParams } from 'react-router'
import React, {useEffect, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { decryptPassword, encryptPassword } from "../../utils/crypto";

function Reset() {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [codigoParams] = useState(useParams().codigo);
    const [cod, setCod] = useState();

    useEffect(() => {
        setCod(codigoParams);
    }, [codigoParams]);

    const [senhas, setSenhas] = useState({
            novaSenha: '',
            confirmaSenha: '',
            codigo: codigoParams
        });

    function handleInputChange(event) {
        const { name, value } = event.target;
        setSenhas(prevSenhas => ({
          ...prevSenhas,
          [name]: value
        }));
      }
//console.log(senhas);
    function handleFormSubmit(event) {
        event.preventDefault();
        // Lógica para enviar o formulário de contato
        if (!senhas.novaSenha || !senhas.confirmaSenha) {
          alert('Por favor, preencha todos os campos antes de enviar.');
          return;
        }
        if (senhas.novaSenha !== senhas.confirmaSenha) {
            alert('As senhas não coincidem. Por favor, verifique e tente novamente.');
            return;
          }


        senhas.novaSenha = encryptPassword(senhas.novaSenha);
//console.log(senhas);
        axios
        .post(process.env.REACT_APP_API_URL +
            '/routes.php?metodo=resetSenha', 
            senhas, 
            { headers: {
                        "X-Access-Token" : "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00",
                        "Content-Type": "application/json; charset=UTF-8"
                    } })
            .then(responseReset => {
              alert(responseReset.data.message);
              //console.log(responseReset.data);

                //enviar email para o usuário informando sobre a troca de senha
                axios
                    .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=obtemModeloEmailPorDescricao', 
                        {
                            emlDescricao: 'ResetDeSenhaConfirmado'
                        }, 
                        {
                            headers: {
                                "X-Access-Token": "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00",
                                "Content-Type": "application/json; charset=UTF-8"
                            }
                        }
                    )
                    .then(responseModelo => {
                        const modeloEmail = responseModelo.data;
                        //console.log(responseModelo.data);
                        axios
                        .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=obtemCadastroAssociado',
                            {
                                associado: 1,
                                IdPessoa: 0,
                                pesEmail: '',
                                pesCodigoGUID: codigoParams
                            },
                            {
                                headers: {
                                    "X-Access-Token": "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00",
                                    "Content-Type": "application/json; charset=UTF-8"
                                }
                            }
                        )
                        .then(responseUsuario => {
                            const usuario = responseUsuario.data;
                            //console.log(responseUsuario.data);
                            let mess = modeloEmail.emlCorpo;
                            mess = mess.replace('[nome]', usuario.pesNome);
                            mess = '<img src="https://www.brasilextremos.com.br/api/uploads/fotos/logo_mgbe.png" alt="Logo MGBE" style="width: 100px; margin-top: 20px;" /></ br> ' + mess;
                            
                            const dadosEmail = {
                                nome: responseUsuario.data.pesNome,
                                email: responseUsuario.data.pesEmail,
                                assunto: responseModelo.data.emlAssunto,
                                mensagem: mess
                            };
                            axios
                            .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=enviarEmail',
                                dadosEmail, {
                                    headers: {
                                        "X-Access-Token": "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00",
                                        "Content-Type": "application/json; charset=UTF-8"
                                    }
                                }
                            )
                            .then(responseEmail => {
                                console.log('Email enviado com sucesso:', responseEmail.data);
                            })
                            .catch(error => {
                                console.error('Erro ao enviar email:', error);
                            });
                        })
                        .catch(error => {
                            console.error('Erro ao obter dados do usuário:', error);
                        })
                    })
                    .catch(error => {
                        console.error('Erro ao obter modelo de email:', error);
                    });

              navigate('/#/Login');
            })
            .catch(error => {
              alert(error.message);
            });
    }
    
    //const { novaSenha: password, confirmaSenha: confirmPassword } = senhas;

    return (
        <>
            <main>
                <div className='headerMain'>
                    <label className='labelTitulo' >Reset de senha</label>                
                    <h4>Informe a nova senha</h4>
                </div>
                <div>
                    <form onSubmit={handleFormSubmit}>
                        <div className="d-flex w100 flex-column tdAlignLeft pb4"> 
                            <div className="d-flex flex-column divForm">
                                <input
                                className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                required
                                id="novaSenha"
                                name="novaSenha"
                                type={show ? 'text' : 'password'}
                                placeholder="Senha"
                                value={senhas.novaSenha}
                                onChange={handleInputChange}
                                />
                            </div>

                            <div className="d-flex flex-column divForm">
                                <input
                                className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                required
                                id="confirmaSenha"
                                name="confirmaSenha"
                                placeholder="Confirmar senha"
                                type={show ? 'text' : 'password'}
                                value={senhas.confirmaSenha}
                                onChange={handleInputChange}
                                />
                            </div>
                                <label className="fs12 p1 text-align-left">
                                Visualizar texto
                                <input 
                                    type="checkbox"
                                    style={{ marginLeft: '20px', transform: 'scale(1.5)' }}
                                    checked={show}
                                    onChange={() => setShow(!show)}
                                    className="ml1"
                                />
                                </label>
                            <div className='text-align-left p2 m3 divForm fs14'>
                                <button 
                                    className='buttonModalPadrao p1 w100 fs14'
                                    type="submit">Salvar nova senha</button>
                            </div>
                        </div>
                    </form>
                </div>
            </main>
        </>
    );
}
                              

export default Reset;